type TParams = {
  firstName: string;
  lastName: string;
  titleBeforeName?: string | null;
  titleAfterName?: string | null;
};

const ORDER: (keyof TParams)[] = ['titleBeforeName', 'firstName', 'lastName', 'titleBeforeName'];

function getFullNameFromProfile(profile?: TParams) {
  if (!profile) {
    return '-';
  }

  return ORDER.reduce((acc, i) => {
    if (profile[i]) {
      acc.push(profile[i] as string);
    }
    return acc;
  }, [] as string[]).join(' ');
}

export default getFullNameFromProfile;
